/**
 * ScrollToTop component
 * Automatically scrolls to the top of the page when the route changes
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // IMPORTANT:
    // Form (/form/*) must not auto-scroll on landing; scrolling should be user-driven.
    if (pathname.startsWith('/form')) {
      return;
    }

    // Scroll to top when route changes (instant to avoid animation-induced discomfort)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  }, [pathname]);

  return null; // This component doesn't render anything
};
